import React, { useEffect, useState } from "react";
import "../../assets/styles/VisitorStatisticsStyle/VisitorStatisticsMostState.css";
import { convertObjToArray } from "../../helper/Helper";
import axios from "../../js/Axios/Axios";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
export default function VisitorStatisticsMostState() {
  const [data, setData] = useState([]);
  useEffect(() => {
    axios
      .get("/visitInfo/mostVisitedStatesReport")
      .then((res) => {
        console.log(res);
        setData(convertObjToArray(res.data.data));
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div className="visitor-statistics-most-state">
      <div className="visitor-statistics-most-state-title-box">
        <p>پر بازدیدترین استان ها</p>
      </div>
      <div className="visitor-statistics-most-state-box">
        <div className="visitor-statistics-most-state-top-bar">
          <div className="visitor-statistics-most-state-top-bar-hashtag">
            <p>#</p>
          </div>
          <div className="visitor-statistics-most-state-top-bar-state">
            <p>استان</p>
          </div>
          <div className="visitor-statistics-most-state-top-bar-count">
            <p>تعداد بازدیدکنندگان</p>
          </div>
        </div>
        <SimpleBar
          forceVisible="y"
          className="visitor-statistics-most-state-item-box"
        >
          {data.map((item, index) => {
            return (
              <div key={index} className="visitor-statistics-most-state-item-1">
                <div className="visitor-statistics-most-state-item-hashtag">
                  <p>{index + 1}</p>
                </div>
                <div className="visitor-statistics-most-state-item-state">
                  <p>{item.key}</p>
                </div>
                <div className="visitor-statistics-most-state-item-number">
                  <p>{item.value}</p>
                </div>
              </div>
            );
          })}
        </SimpleBar>
      </div>
    </div>
  );
}
